import { Grid, Space } from '@mantine/core';
import { CustomSelect, CustomTextInput } from '../styles';
import { useContext, useMemo } from 'react';
import { AvicContext } from './context';
import MantineTable from '../../../common/table/mantine';
import { skuColumns } from '../stockPriceExtension/selectSku';
import { CostingRequestsContext } from '../../../contexts/CostingRequest';

export const Form = () => {
  const { skus, loaders } = useContext(CostingRequestsContext);
  const { form, onFormChange, countries, salesOrgs, selectedSku, setSelectedSku } =
    useContext(AvicContext);
  const { country, sales_org } = form || {};

  const columns = useMemo(() => skuColumns, [skus]);

  const handleRowSelection = (data) => {
    let currentValues = { ...selectedSku };
    currentValues = { ...data };
    const newValue = Object.keys(currentValues)?.[0];

    onFormChange('sku_number', newValue);
    setSelectedSku(currentValues);
  };

  return (
    <>
      <Grid>
        <Grid.Col span={6}>
          <CustomSelect
            name='country'
            value={country}
            label='Select Country'
            placeholder='Select Country'
            data={countries}
            onChange={(value) => {
              const org = salesOrgs.filter((org) => org.includes(value));
              onFormChange('country', value, org[0]);
            }}
            searchable
            withAsterisk
          />
        </Grid.Col>

        <Grid.Col span={6}>
          <CustomTextInput
            name='sales_org'
            readOnly={true}
            value={sales_org}
            label='Sales Org'
            placeholder='Sales Org'
            withAsterisk
          />
        </Grid.Col>

        <Space h='md' />
        <Grid.Col span={12}>
          <MantineTable
            columns={columns}
            initialData={skus}
            unique={'sku'}
            handleRowSelection={handleRowSelection}
            activeRows={selectedSku}
            enableRowSelection={true}
            loading={loaders.skus}
            hideSelectColumn={false}
            showResetAll={false}
            fullScreen={false}
            multiRowSelection={false}
            showSelectedToggle={true}
            pageSize={10}
          />
        </Grid.Col>
      </Grid>
    </>
  );
};
